import FullScreen from './FullScreen';

export default FullScreen;
